import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SiteHeaderOverlay.scss';

const SiteHeaderOverlay = ({ isActive, showMinSpend = false }) => {
  return (
    <div
      className={classNames(styles[isActive ? 'overlayActive' : 'overlay'], {
        [styles.minSpendActive]: showMinSpend,
      })}
    />
  );
};

SiteHeaderOverlay.propTypes = {
  isActive: PropTypes.bool.isRequired,
  showMinSpend: PropTypes.bool,
};

export default SiteHeaderOverlay;
